export default {"src":"__ASTRO_ASSET_IMAGE__B4$b4xG4__","width":1080,"height":1492,"format":"jpg"}